import React, { useEffect, useState, useRef, useCallback } from 'react'
import './SchedulerNewSS.css'
import Week from './Components/Week'
import DatePickerSS from '../../DatePickerSS/DatePickerSS'
import { createWPMetaData, displayLoader, formatDate_MM_DD_YYYY, showLoader, showLoaderScheduler } from '../../../Assests/Utility'
import { convertToJSDate } from './helpers/genrrals'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import { smartScheduleSelector } from '../../../../redux/reducers/reducerSlices/SmartScheduleReducer'
import { AppConstant } from '../../../Assests/AppConstant'
import moment from 'moment'
import CustomDropDownSS from '../../Common/CustomDropDown/CustomDropDownSS'
import { sagaActions } from '../../../../sagas/sagaActions'
import { getUserSelector } from '../../../../redux/reducers/reducerSlices/UserReducer'
import ScheduleProWrapper from '../SchedulePro/ScheduleProWrapper'
import CustomButtonSS from '../../Common/CustomButton/CustomButtonSS'
import CommonToggleSwitch from '../../Common/CommonToggleSwitch/CommonToggleSwitch'
import { fetchLeavesDocksListCommonFunc } from '../../LandingPage/SmartScheduler/WarehouseMetaData/Forms/LeavesForm/Common/FetchLeavesList'
import { getWhMetaDataReducerSlice } from '../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice'
import { fetchBreakListCommonFunc, fetchBreaksDocksListCommonFunc } from '../../LandingPage/SmartScheduler/WarehouseMetaData/Forms/BreaksForm/Common/FetchBreakList'
import { SSAppointmentSearch } from '../SchedulePro/Components/DashBoard/Children/SSAppointmentSearch/SSAppointmentSearch'
import ModalSS from '../SchedulePro/Components/Common/ModalSS/ModalSS'
import { fetchDockListCommonFunc } from '../../LandingPage/SmartScheduler/WarehouseMetaData/Forms/DocksMeta/Common/FetchDockList'
import { closeUpdatesSocketConnection, initializeUpdatesSocketConnection } from '../../../../Utils/updateSocket'
import { addDaysToDate } from '../../../../Utils/DateUtils'
import { format } from 'date-fns'

function SchedulerNewSS(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ss = useSelector(smartScheduleSelector);
    const {
      appointmentList,
      initateLoading,
      schedulerIsLoading,
      docksIsLoading,
      leavesIsLoading,
      breaksIsLoading,
      searchedPOData,
      searchedPOErrorData,
      defaultDockValue,
      standingAppointmentsList
    } = ss;

    const user = useSelector(getUserSelector);
    const { cu_id, userType, selectedWarehouse } = user;
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { whMetaLeavesList ,whMetaBreaksList ,whMetaDocksList, isLoading: metadataIsLoading} = whMetaData;
    
    // Track if this is the first page load
    const isFirstLoadRef = useRef(true);
    
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [showCalendar, setShowCalendar]= useState(false);
    const [apptList,setApptList]= useState([])
    const [dockList,setDockList] = useState([])
    const [eventList,setEventList]=useState([])
    const [startHour,setStartHour]=useState(null);
    const [endHour,setEndHour]=useState(null);
    const [standingAppointmentBlocksForScheduler, setStandingAppointmentBlocksForScheduler] = useState([])
    const [breakList,setBreakList]=useState([])
    const [whBreaks,setWhBreaks]= useState([])
    const [dockBreaks,setDockBreaks]= useState([])
    const [showScheduleModal,setShowScheduleModal] = useState(false)
    const [scheduleScreenType, setScheduleScreenType] = useState('');
    const [issearched, setIsSearched] = useState(false);
    const [po_number, setPo_number] = useState(null);
    const [receivingZipcode, setReceivingZipcode] = useState(null);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [didSearched, setDidSearched] = useState(false);
    const [searchPoDataState, setSearchPoDataState] = useState(null);
    const [selectedDock, setSelectedDock] = useState(null)
    const [shouldRender, setShouldRender] = useState(false)
    const [placeHolderDock, setPlaceHolderDock] = useState(false)
  const [defaultDockValueState, setDefaultDockValueState] = useState(false)
  // socketRef converted from useState to useRef to avoid stale closures
  // and prevent re-renders on socket state changes
  const socketRef = useRef(null)
  // Stable refs for WebSocket reconnect counter, timers, and current state.
  // Declared here (before all useEffects) so cleanup closures always have valid references.
  const reconnectAttemptRef = useRef(0)
  const reconnectTimerRef = useRef(null)
  const calendarRefreshTimerRef = useRef(null)
  const selectedDateRef = useRef(null) // kept in sync via useEffect below
  const selectedWarehouseRef = useRef(null) // kept in sync via useEffect below
  const [allApisLoaded, setAllApisLoaded] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [requestSequence, setRequestSequence] = useState(0)
  const [readyWeekData, setReadyWeekData] = useState({
    events: [],
    breaks: [],
    leaves: [],
    standingAppointments: []
  })
  const [dockOperationalDays, setDockOperationalDays] = useState({
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false
  })
  
  const resetScheduleCalendar = () => {
    dispatch({ type: sagaActions.RESET_SCHEDULE_CALENDAR })
  }
  

  // Wait for ALL 4 API loaders to complete before showing content
  useEffect(() => {
    const allLoadersComplete = 
      schedulerIsLoading === false && 
      docksIsLoading === false && 
      leavesIsLoading === false && 
      breaksIsLoading === false;
    
    // Show content only when all APIs are done loading
    if (allLoadersComplete && isInitialized && appointmentList !== undefined) {
      const timeout = setTimeout(() => {
        setShouldRender(true);
        if (isFirstLoadRef.current) {
          isFirstLoadRef.current = false; 
        }
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [schedulerIsLoading, docksIsLoading, leavesIsLoading, breaksIsLoading, isInitialized, appointmentList])

 
  useEffect(() => {
    setReadyWeekData({
      events: eventList,
      breaks: formatBreaksForScheduler(breakList),
      leaves: whMetaLeavesList ? whMetaLeavesList : [],
      standingAppointments: standingAppointmentBlocksForScheduler || []
    })
  }, [eventList, breakList, whMetaLeavesList, selectedDock, standingAppointmentBlocksForScheduler])
  
    const onEmailChange = (e, type) => {
      if (type === 'po') {
          setPo_number(e)
      } else if (type === 'zipcode') {
          setReceivingZipcode(e)
      }
  }


      const fetchStandingAppointments = (date = selectedDate) => {
          const payload = {
              ID: null,
              IDWarehouse: selectedWarehouse?.ID,
              IDDock: null,
              IDCarrier: null,
              StartDateTime: null,
              EndDateTime: null,
              ApptStartDateTime: null,
              DurationMins: null,
              Frequency: null,
              WeeklyData: null,
              RuleProcessingStatus: null,
              IsActive: null,
              IsDeleted: 0,
              CreatedOn: null,
              CreatedBy: null,
              UpdatedOn: null,
              UpdatedBy: null,
              CRUDTYPE: 'S',
              Date: date ? moment.utc(date).format('YYYY-MM-DD') : null
          }
          const operationObj = {
              type: 'Standing Appointments List',
          }
          dispatch({ type: sagaActions.STANDING_APPOINTMENT_ACTION, payload, operationObj })
      }
  
  const displayAppointmentsList = () => {
    setSearchPoDataState([])
    // dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO, payload: [] })
    // dispatch({ type: sagaActions.SET_SS_SELECTED_PO_FOR_APPT, payload: [] })
    if (po_number && receivingZipcode) {
        setDidSearched(true)
        dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: true })
        dispatch({ type: sagaActions.INTIATE_SS_SEARCH_PO, payload: { PoNumber: po_number, ReceivingZipCode: receivingZipcode, UserType: userType, ID: userType === 'CARRIER' ? cu_id : selectedWarehouse?.ID } })
    } else {
        dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO_ERROR, payload: '* Both PO and Zip Code are mandatory' })
        // showAlert(toast.TYPE.WARNING, 'Both PO and Zip Code are mandatory', 'light')
    }
  
  }

  /**
   * Function to fetch dock list
   */
  const fetchDockList = () => {
    const { apiParams, operationObj } = fetchDockListCommonFunc(selectedWarehouse, cu_id);
    dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj })
}
  
    useEffect(() => {
    setDidSearched(false)
    setShowHelpModal(false);
    dispatch({ type: sagaActions.CLEAR_APPOINTMENT_TRACKER })
    dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: false })
  
    // Show loader on mount
    setShouldRender(false);
    setIsInitialized(true);
  
    if (userType === 'USER') {
        setReceivingZipcode(selectedWarehouse?.Zip)
    }
  
    return () => {
        dispatch({ type: sagaActions.CLEAR_SS_SEARCH_PO });
        dispatch({ type: sagaActions.UPDATE_SS_SEARCH_PO_ERROR, payload: null });
    }
  }, [])

  // Cleanup on unmount — reads socketRef.current (always current) instead of
  // the stale closure that previously captured the initial null value of useState socketRef.
  // Also clears any pending debounce/reconnect timers to prevent post-unmount activity.
  useEffect(() => {
    return () => {
      // Clear pending debounce and reconnect timers
      if (calendarRefreshTimerRef.current) {
        clearTimeout(calendarRefreshTimerRef.current)
        calendarRefreshTimerRef.current = null
      }
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current)
        reconnectTimerRef.current = null
      }
      // Close and nullify the socket
      if (socketRef.current) {
        const old = socketRef.current
        old.onmessage = null
        old.onerror = null
        old.onclose = null
        old.onopen = null
        try {
          closeUpdatesSocketConnection(old, selectedWarehouse.ID)
        } catch (e) {
          // ignore close errors on unmount
        }
        socketRef.current = null
        // console.log('[Scheduler WS] Component unmounting. Socket closed.')
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  // Keep selectedDateRef and selectedWarehouseRef in sync with current state
  // so WebSocket callbacks always read the latest values without stale closures
  useEffect(() => { selectedDateRef.current = selectedDate }, [selectedDate])
  useEffect(() => { selectedWarehouseRef.current = selectedWarehouse }, [selectedWarehouse])

  // Debounced calendar refresh 
  // Coalesces N burst APPT_END_TIME events into a single GET_SCHEDULER_DATA dispatch.
  // 1500ms window absorbs message bursts delivered after reconnect.
  const scheduleDebouncedCalendarRefresh = useCallback((date) => {
    if (calendarRefreshTimerRef.current) {
      clearTimeout(calendarRefreshTimerRef.current)
      // console.log('[Scheduler] Calendar refresh debounced — timer reset. Will fire in 1500ms.')
    } else {
      // console.log('[Scheduler] Calendar refresh debounce timer started. date=', date)
    }
    calendarRefreshTimerRef.current = setTimeout(() => {
      calendarRefreshTimerRef.current = null
      const whID = selectedWarehouseRef.current?.ID
      if (whID) {
        // console.log('[Scheduler] GET_SCHEDULER_DATA dispatched after debounce. WHid=', whID, 'date=', date)
        dispatch({
          type: sagaActions.GET_SCHEDULER_DATA,
          payload: { IDWarehouse: whID, DateSelected: date, CalendarView: 'WEEK' },
        })
      } else {
        console.warn('[Scheduler] Debounce fired but selectedWarehouseRef.current?.ID is empty — skipping dispatch.') 
        
      }
    }, 1500)
  }, [dispatch])

  // Safe socket close
  // Nullifies all handlers on the old socket BEFORE closing it, so that pending
  // onerror/onclose callbacks cannot fire after we have already moved on to a new
  // socket. This prevents the "old socket fires → new reconnect triggered" cascade.
  const safeCloseCurrentSocket = useCallback(() => {
    if (socketRef.current) {
      const old = socketRef.current
      // console.log('[Scheduler WS] Closing old socket. readyState=', old.readyState, '(0=CONNECTING,1=OPEN,2=CLOSING,3=CLOSED)')
      old.onmessage = null
      old.onerror = null
      old.onclose = null
      old.onopen = null
      try {
        closeUpdatesSocketConnection(old, selectedWarehouseRef.current?.ID)
      } catch (e) {
        console.warn('[Scheduler WS] Error during socket close (ignored):', e)
      }
      socketRef.current = null
      // console.log('[Scheduler WS] Old socket handlers nullified and socket closed.')
    } else {
      // console.log('[Scheduler WS] safeCloseCurrentSocket called but no existing socket to close.')
    }
  }, [])

  // Stable callback — onUpdateSocketReceived
  // useCallback + reading state via refs avoids stale closure bugs where the
  // callback registered on the WebSocket reads outdated React state values.
  const onUpdateSocketReceived = useCallback((message, date) => {
    // console.log('[Scheduler WS] onUpdateSocketReceived fired. raw message=', message, 'date=', date)
    let parsedMessage
    try {
      parsedMessage = JSON.parse(message)
      if (typeof parsedMessage === 'string') {
        parsedMessage = JSON.parse(parsedMessage)
      }
    } catch (e) {
      console.error('[Scheduler WS] Failed to parse WebSocket message:', e, 'raw=', message)
      return
    }

    if (!_.isEmpty(parsedMessage)) {
      const { type } = parsedMessage
      // console.log('[Scheduler WS] Message parsed. type=', type, 'reconnectAttemptRef.current=', reconnectAttemptRef.current)
      // Reset reconnect counter — connection is healthy
      reconnectAttemptRef.current = 0

      switch (type) {
        case 'APPT_END_TIME':
          // Debounced — N queued messages → 1 Calendar API call
          scheduleDebouncedCalendarRefresh(date)
          break
        case 'DOCK_STATUS':
          fetchDockList()
          break
        case 'DOCK_PPH':
          fetchDockList()
          break
        case 'DOCK_START_TIME':
          // Currently in week, Dock start and End time are not highlighted
          break
        case 'DOCK_END_TIME':
          // Currently in week, Dock start and End time are not highlighted
          break
        case 'DOCK_BREAK_STATUS':
          fetchBreakDockList()
          break
        case 'DOCK_BREAK_START_TIME':
          fetchBreakDockList()
          break
        case 'DOCK_BREAK_END_TIME':
          fetchBreakDockList()
          break
        case 'DOCK_BREAK_DESCRIPTION':
          fetchBreakDockList()
          break
        case 'DOCK_BREAK_DELETED':
          fetchBreakDockList()
          break
        case 'DOCK_LEAVE_STATUS':
          fetchDocksLeaveList()
          break
        case 'DOCK_LEAVE_START_TIME':
          fetchDocksLeaveList()
          break
        case 'DOCK_LEAVE_END_TIME':
          fetchDocksLeaveList()
          break
        case 'DOCK_LEAVE_DESCRIPTION':
          fetchDocksLeaveList()
          break
        case 'DOCK_LEAVE_DELETED':
          fetchDocksLeaveList()
          break
        case 'DOCK_OPERATION_DAY':
          fetchDockList()
          break
        case 'DOCK_DOOR_STATUS':
          fetchDockList()
          break
        case 'DOCK_DOOR_TIMESLOTNAME':
          fetchDockList()
          break
        case 'DOCK_DOOR_TIMESLOTSTATUS':
          fetchDockList()
          break
        case 'DOCK_DOOR_DELETED':
          fetchDockList()
          break
        default:
          break
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleDebouncedCalendarRefresh])

  // scheduleReconnect — circuit breaker + exponential backoff
  // Replaces the immediate unbounded retry with: max 5 attempts, delays of
  // 1s → 2s → 4s → 8s → 16s (capped at 30s). Counter resets on successful message.
  const MAX_RECONNECT_ATTEMPTS = 5
  const scheduleReconnect = useCallback(() => {
    // console.log('[Scheduler WS] scheduleReconnect called. currentAttempt=', reconnectAttemptRef.current, 'max=', MAX_RECONNECT_ATTEMPTS)
    if (reconnectAttemptRef.current >= MAX_RECONNECT_ATTEMPTS) {
      console.warn('[Scheduler WS] Max retries reached. Stopping all reconnect attempts.')
      return
    }
    if (window.location.pathname !== '/wpscheduleappointments') {
      // console.log('[Scheduler WS] Not on scheduler page — skipping reconnect. pathname=', window.location.pathname)
      return
    }
    if (reconnectTimerRef.current) {
      clearTimeout(reconnectTimerRef.current)
    }
    const attempt = reconnectAttemptRef.current
    const delay = Math.min(30000, 1000 * Math.pow(2, attempt))
    reconnectAttemptRef.current = attempt + 1
    // console.log('[Scheduler WS] Reconnect scheduled in', delay, 'ms. Attempt', reconnectAttemptRef.current, '/', MAX_RECONNECT_ATTEMPTS)
    reconnectTimerRef.current = setTimeout(() => {
      reconnectTimerRef.current = null
      // console.log('[Scheduler WS] Reconnect timer fired — calling validateURLandFetchAppointments.')
      validateURLandFetchAppointments()
    }, delay)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * Change 3+5: onUpdateSocketError — uses scheduleReconnect (circuit breaker)
   * instead of calling validateURLandFetchAppointments directly.
   */
  const onUpdateSocketError = useCallback((error) => {
    console.error('[Scheduler WS] Socket ERROR. retryCount=', reconnectAttemptRef.current, 'error=', error)
    scheduleReconnect()
  }, [scheduleReconnect])

  /**
   * onUpdateSocketClose — only reconnects on non-normal closes,
   * now via scheduleReconnect (circuit breaker + backoff).
   */
  const onUpdateSocketClose = useCallback((data) => {
    // console.log('[Scheduler WS] Socket CLOSED. code=', data.code, 'reason=', data.reason, 'wasClean=', data.wasClean, 'retryCount=', reconnectAttemptRef.current)
    if (data.code !== 1000) {
      // console.log('[Scheduler WS] Non-normal close — scheduling reconnect.')
      scheduleReconnect()
    } else {
      // console.log('[Scheduler WS] Normal close (code=1000) — no reconnect.')
    }
  }, [scheduleReconnect])

  const onUpdateSocketOpen = useCallback(() => {
    // console.log('[Scheduler WS] Socket OPENED/CONNECTED. socketRef readyState=', socketRef.current?.readyState)
    reconnectAttemptRef.current = 0
  }, [])

  /**
   * validateURLandFetchAppointments — always closes the old socket
   * before opening a new one. Reads selectedDate and selectedWarehouse from stable
   * refs to avoid stale closure bugs.
   */
  const validateURLandFetchAppointments = useCallback(() => {
    if (window.location.pathname === '/wpscheduleappointments') {
      const whID = selectedWarehouseRef.current?.ID
      const date = selectedDateRef.current

      // Close old socket + nullify handlers before creating new one
      safeCloseCurrentSocket()

      const newSocket = initializeUpdatesSocketConnection(
        whID,
        AppConstant.commonStrings.truckUpdateSocketUrl,
        onUpdateSocketReceived,
        onUpdateSocketError,
        onUpdateSocketClose,
        onUpdateSocketOpen,
        date
      )
      socketRef.current = newSocket
      // console.log('[Scheduler WS] Reconnect socket created. WHid=', whID, 'readyState=', newSocket.readyState, '(0=CONNECTING)')

      // console.log('[Scheduler] GET_SCHEDULER_DATA dispatched via validateURL (reconnect). WHid=', whID, 'date=', date)
      dispatch({
        type: sagaActions.GET_SCHEDULER_DATA,
        payload: { IDWarehouse: whID, DateSelected: date, CalendarView: 'WEEK' },
      })
    } else {
      console.warn('[Scheduler WS] validateURLandFetchAppointments: not on scheduler page. pathname=', window.location.pathname)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeCloseCurrentSocket, onUpdateSocketReceived, onUpdateSocketError, onUpdateSocketClose, onUpdateSocketOpen, dispatch])
  
   const toggleIsSearched = () => {
        setIsSearched(!issearched)
    }
    useEffect(()=>{
      if (searchedPOData.length) {
        setShowScheduleModal(false)
      }
    },[searchedPOData])

    useEffect(()=>{
      if (whMetaBreaksList && whMetaBreaksList.length) {
        const warehouseBreaks = whMetaBreaksList.filter((el) => el.IDWHBreak && el.Status);
        const dockBreaksList = whMetaBreaksList.filter((el) => el.IDDockBreak && el.Status);
        setWhBreaks(warehouseBreaks);
        setDockBreaks(dockBreaksList);
        setBreakList(warehouseBreaks);
      } else {
        setWhBreaks([]);
        setDockBreaks([]);
        setBreakList([]);
      }
    }, [whMetaBreaksList])

    useEffect(() => {
      if (standingAppointmentsList && standingAppointmentsList.length) {
        const formatted = formatStandingAppointmentsForScheduler(standingAppointmentsList, selectedDate)
        setStandingAppointmentBlocksForScheduler(formatted)
      } else {
        setStandingAppointmentBlocksForScheduler([])
      }
    }, [standingAppointmentsList, selectedDate])

    useEffect(() => {
      if (_.size(selectedDock)) {
        const dockselectedbreakslist = dockBreaks.filter((el) => el.IDDock === selectedDock[0]?.dockId && el.Status);
        if (dockselectedbreakslist && dockselectedbreakslist.length) {
          setBreakList(dockselectedbreakslist);
        } else {
          setBreakList(whBreaks);
        }
      } else {
        setBreakList([...whBreaks, ...dockBreaks]);
      }
    }, [dockBreaks, whBreaks, selectedDock])

    const fetchDocksLeaveList = () => {
      const { apiParams, operationObj } = fetchLeavesDocksListCommonFunc(selectedWarehouse);
      dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj })
  }
  const fetchBreakDockList = () => {
    const { apiParams, operationObj } = fetchBreaksDocksListCommonFunc(selectedWarehouse);
    dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj })
}

const fetchBreakList = () => {
    const { apiParams, operationObj } = fetchBreakListCommonFunc(selectedWarehouse);
    dispatch({ type: sagaActions.WAREHOUSE_META_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj })
}

    useEffect(() => {
      // console.log('[Scheduler] selectedWarehouse.ID useEffect fired. WHid=', selectedWarehouse?.ID)
      dispatch({ type: sagaActions.CLEAR_SS_SEARCH_PO })
            
      // Show loader when initializing
      setIsInitialized(true);
      setShouldRender(false);
            
      if (selectedWarehouse?.ID) {
        dispatch({ type: sagaActions.CLEAR_APPOINTMENT_TRACKER })
        dispatch({ type: sagaActions.RESET_WAREHOUSE_META_DOCK_LIST_ACTION, payload: [] })
        resetScheduleCalendar()
            
        dispatch({
          type: sagaActions.GET_SCHEDULER_DATA,
          payload: {
            IDWarehouse: selectedWarehouse?.ID, 
            DateSelected: selectedDate,
            CalendarView: 'WEEK'
          },
        });
    
        const wpCapacityData = createWPMetaData("wpCapacityData", "S", {
          IDWarehouse: selectedWarehouse?.ID,
        });
        const wpLeaveData = createWPMetaData("wpLeaveData", "S", {
          IDWarehouse: selectedWarehouse?.ID, 
          Status: 1
        });
    
        dispatch({
          type: sagaActions.INITIATE_WAREHOUSE_METADATA,
          payload: { payload: wpCapacityData, key: "wpCapacityData" },
        });
        dispatch({
          type: sagaActions.INITIATE_WAREHOUSE_METADATA,
          payload: { payload: wpLeaveData, key: "wpLeaveData" },
        });
        
        fetchDocksLeaveList()
        fetchBreakDockList()
        fetchDockList()
        fetchStandingAppointments()
        dispatch({ type: sagaActions.CLEAR_SS_SEARCH_PO })

        // Initialize the WebSocket on initial warehouse load.
        // console.log('[Scheduler WS] Initializing socket on warehouse load. WHid=', selectedWarehouse?.ID)
        safeCloseCurrentSocket()
        reconnectAttemptRef.current = 0
        const initSocket = initializeUpdatesSocketConnection(
          selectedWarehouse.ID,
          AppConstant.commonStrings.truckUpdateSocketUrl,
          onUpdateSocketReceived,
          onUpdateSocketError,
          onUpdateSocketClose,
          onUpdateSocketOpen,
          selectedDate
        )
        socketRef.current = initSocket
        // console.log('[Scheduler WS] Socket initialized on warehouse load. WHid=', selectedWarehouse?.ID)
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedWarehouse?.ID])
  
  useEffect(() => {
    if (selectedDate && !isFirstLoadRef.current) {
      setReadyWeekData({ events: [], breaks: [], leaves: [] });
      setShouldRender(false);

      dispatch({ type: sagaActions.CLEAR_APPOINTMENT_TRACKER })
      dispatch({ type: sagaActions.GET_SCHEDULER_DATA, payload: { type: 'C' } })
      resetScheduleCalendar()

      // Clear any pending debounce and reconnect timers on intentional date navigation
      if (calendarRefreshTimerRef.current) {
        clearTimeout(calendarRefreshTimerRef.current)
        calendarRefreshTimerRef.current = null
      }
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current)
        reconnectTimerRef.current = null
      }
      // Reset retry counter — this is an intentional navigation, not a failure
      reconnectAttemptRef.current = 0

      // Change 2: Use safeCloseCurrentSocket to properly close and nullify old socket
      // before creating the new one for the new date
      safeCloseCurrentSocket()

      const newSocket = initializeUpdatesSocketConnection(
        selectedWarehouse.ID,
        AppConstant.commonStrings.truckUpdateSocketUrl,
        onUpdateSocketReceived,
        onUpdateSocketError,
        onUpdateSocketClose,
        onUpdateSocketOpen,
        selectedDate
      )
      socketRef.current = newSocket
      // console.log('[Scheduler WS] New socket for date change. WHid=', selectedWarehouse.ID, 'readyState=', newSocket.readyState)

      dispatch({
        type: sagaActions.GET_SCHEDULER_DATA,
        payload: {
          IDWarehouse: selectedWarehouse?.ID,
          DateSelected: moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          CalendarView: 'WEEK'
        },
      });
      fetchDocksLeaveList()
      fetchBreakDockList()
      fetchDockList()
      fetchStandingAppointments(selectedDate)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate])


    const createDockList=(docklist) => {
        let startHourList =docklist.map((el)=>el.StartTime)
        let endHourList =docklist.map((el)=>el.EndTime)
        let minStartHour=_.min(startHourList)
        let maxEndHour=_.max(endHourList)
      
        let newDockList=[]
        let sorted_docklist = _.sortBy(docklist,
          [function (o) { return o.Name; }]);
          sorted_docklist.forEach(el=>{
            if (el.DockStatus) {
              let obj={};
        obj.dockId=el.dockId;
        obj.dockName=el.Name
        obj.dockColor=el.DockColorCode || ""
        obj.dockStart=convertToJSDate(moment(el.StartTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours()
        obj.dockEnd=convertToJSDate(moment(el.EndTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours()
            newDockList.push(obj)
            }
            
        })
        let alldock={
          dockId:"0000",
          dockName:"ALL",
          dockColor:"#E39898",
          dockStart:convertToJSDate(moment(minStartHour).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours(),
          dockEnd:convertToJSDate(moment(maxEndHour).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours()
        }
        newDockList.push(alldock)
        setDockList(newDockList)
        return newDockList
    }

    const formatDataForScheduler=(data)=>{
      let updatedList=[]
      data.length && data.forEach(el => {
        if (el.PORelationID && el.PoNumber !== el.PORelationID) return;
        if (el?.ApptStartTime) {
          let res = { ...el }
          res.start = convertToJSDate(moment(el.ApptStartTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
          res.end = convertToJSDate(moment(el.ApptEndTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
          res.event_id = el.IDPO;
          res.disabled = false;
          updatedList.push(res)
        }
      });
      return updatedList
  }

  const formatBreaksForScheduler=(data)=>{
    let updatedList=[]
    data.length && data.forEach(el => {
      if (el.Status) {
        let res={...el}
        res.start=convertToJSDate(moment(el.BreakStart).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
        res.end=convertToJSDate(moment(el.BreakEnd).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
        res.event_id=el.IDWarehouse+"_"+(el.IDDockBreak || el.IDWHBreak || el.ID);
        res.disabled=true;
        updatedList.push(res)
      }
    });
    return updatedList
}

  const getStandingApptWeeklyFlags = (standingAppt) => {
    const flags = {
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
    };

    if (!standingAppt) return flags;

    const weeklyData = standingAppt.WeeklyData;
    let parsedWeeklyData = weeklyData;

    if (typeof weeklyData === 'string') {
      try {
        parsedWeeklyData = JSON.parse(weeklyData);
      } catch (error) {
        parsedWeeklyData = weeklyData;
      }
    }

    if (Array.isArray(parsedWeeklyData)) {
      flags.sunday = parsedWeeklyData.includes(7);
      flags.monday = parsedWeeklyData.includes(1);
      flags.tuesday = parsedWeeklyData.includes(2);
      flags.wednesday = parsedWeeklyData.includes(3);
      flags.thursday = parsedWeeklyData.includes(4);
      flags.friday = parsedWeeklyData.includes(5);
      flags.saturday = parsedWeeklyData.includes(6);
    } else if (parsedWeeklyData && typeof parsedWeeklyData === 'object') {
      flags.sunday = parsedWeeklyData.sunday === true;
      flags.monday = parsedWeeklyData.monday === true;
      flags.tuesday = parsedWeeklyData.tuesday === true;
      flags.wednesday = parsedWeeklyData.wednesday === true;
      flags.thursday = parsedWeeklyData.thursday === true;
      flags.friday = parsedWeeklyData.friday === true;
      flags.saturday = parsedWeeklyData.saturday === true;
    }

    if (standingAppt.Frequency === 'DAILY' && !Object.values(flags).some(Boolean)) {
      Object.keys(flags).forEach((key) => {
        flags[key] = true;
      });
    }

    return flags;
  }

  const getWeekBoundsForDate = (date) => {
    const selected = moment.utc(date || new Date());
    return {
      weekStart: selected.clone().startOf('week').startOf('day'),
      weekEnd: selected.clone().endOf('week').endOf('day'),
    };
  };

  const formatStandingAppointmentsForScheduler = (data, selectedDate) => {
    if (!data || !data.length) return [];

    const { weekStart, weekEnd } = getWeekBoundsForDate(selectedDate);

    const occurrences = [];

    data.forEach((appt) => {
      const isActive = appt.Status !== false && appt.IsActive !== false && appt.IsDeleted !== true;
      if (!isActive) return;

      const ruleStart = appt.ApptStartDateTime
        ? moment.utc(appt.ApptStartDateTime)
        : appt.StartDateTime
          ? moment.utc(appt.StartDateTime)
          : null;

      if (!ruleStart || !ruleStart.isValid()) return;

      const ruleEnd = appt.EndDateTime ? moment.utc(appt.EndDateTime).endOf('day') : null;
      const duration = Number(appt.DurationMins) || 0;
      const weeklyFlags = getStandingApptWeeklyFlags(appt);
      const ruleStartTime = {
        hour: ruleStart.hour(),
        minute: ruleStart.minute(),
        second: ruleStart.second(),
        millisecond: ruleStart.millisecond(),
      };

      let current = weekStart.clone();
      if (current.isBefore(ruleStart.clone().startOf('day'))) {
        current = ruleStart.clone().startOf('day');
      }

      while (current.isSameOrBefore(weekEnd, 'day')) {
        if (ruleEnd && current.isAfter(ruleEnd, 'day')) {
          break;
        }

        const dayName = current.format('dddd').toLowerCase();
        if (weeklyFlags[dayName]) {
          const occurrenceStart = current.clone()
            .hour(ruleStartTime.hour)
            .minute(ruleStartTime.minute)
            .second(ruleStartTime.second)
            .millisecond(ruleStartTime.millisecond);

          const occurrenceEnd = duration
            ? occurrenceStart.clone().add(duration, 'minutes')
            : occurrenceStart.clone().add(30, 'minutes');

          occurrences.push({
            ...appt,
            ApptStartDateTime: occurrenceStart.format(),
            ApptEndDateTime: occurrenceEnd.format(),
            ApptStartTime: occurrenceStart.format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss),
            ApptEndTime: occurrenceEnd.format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss),
            start: convertToJSDate(occurrenceStart.utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)),
            end: convertToJSDate(occurrenceEnd.utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)),
            BreakStart: occurrenceStart.format(),
            BreakEnd: occurrenceEnd.format(),
            IDDockBreak: appt.ID || appt.IDStandingAppointmentBlockRule || null,
            event_id: `${appt.IDWarehouse || ''}_standing_${appt.ID || appt.IDStandingAppointmentBlockRule || ''}_${occurrenceStart.format('YYYY-MM-DD')}`,
            Status: true,
            disabled: true,
            title: appt.Carrier || appt.CarrierName || 'Standing Appointment Block',
            ApptScheStatus: 'standing',
            ...weeklyFlags,
          });
        }

        current.add(1, 'day');
      }
    });

    return occurrences;
  }

    // const formatLeaveDataForScheduler=(data,start=startHour,end=endHour)=>{
    //   let updatedList=[];
    //   if (start && end) {
    //     data.length && data.forEach(el=>{
    //       if (el.Status) {
    //         let res={...el}
    //     let LeaveEndTime=`${el.LeaveEnd.split("T")[0]}T${end}:00:00.000Z`;
    //     let LeaveStartTime=`${el.LeaveStart.split("T")[0]}T${start<10?"0"+start:start}:00:00.000Z`;
    //     res.start=convertToJSDate(moment(LeaveStartTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
    //     res.end=convertToJSDate(moment(LeaveEndTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
    //     res.event_id=el.CreatedOn+"_"+el.IDWHLeave;
    //     res.disabled=true;
    //     res.title=el.Purpose || el.Description;
    //     updatedList.push(res)
    //       }
    //   })
    // }
    //   return updatedList
  // }
  const checkIfDockIsActive = (dataArray, sel) => {
    // Assuming your data is stored in dataArray
    const filteredData = _.filter(dataArray, (el) => {
      return el.ID === sel.dockId && el.
        DockStatus
        === true;
    });
    if (_.size(filteredData)) {
      return true
    } else {
      return false
    }

  }

  const hasConflictingAppointment = (standingAppt, appointments) => {
    const standingStart = standingAppt.start instanceof Date ? standingAppt.start.getTime() : new Date(standingAppt.start).getTime();

    return appointments.some(appt => {
      if(appt?.ApptStartTime){
      // Format start and end for the appointment, similar to formatDataForScheduler
      const apptStart = convertToJSDate(moment(appt.ApptStartTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
      const apptEnd = convertToJSDate(moment(appt.ApptEndTime).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss));
      
      const appointmentStart = apptStart instanceof Date ? apptStart.getTime() : new Date(apptStart).getTime();
      const appointmentEnd = apptEnd instanceof Date ? apptEnd.getTime() : new Date(apptEnd).getTime();
      
      // Skip if times are invalid
      if (isNaN(appointmentStart) || isNaN(appointmentEnd) || isNaN(standingStart)) {
        return false;
      }
      
      const isHidden = appt.IDCarrier === standingAppt.IDCarrier &&
        appt.IDDock === standingAppt.IDDock &&
        appointmentStart === standingStart &&
        standingAppt.DurationMins <= (appointmentEnd - appointmentStart) / (1000 * 60)
      return (
        isHidden
      );
    }
    });
  }

    useEffect(()=>{
      if (whMetaDocksList.length) {
        let startHourList =whMetaDocksList.map((el)=>el.StartTime)
        let endHourList =whMetaDocksList.map((el)=>el.EndTime)
        let minStartHour=_.min(startHourList)
        let maxEndHour=_.max(endHourList)
        setStartHour(convertToJSDate(moment(minStartHour).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours())
        setEndHour(convertToJSDate(moment(maxEndHour).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getHours())
        const data = whMetaDocksList[0];
        const { DefaultIDDock } = data;
        dispatch({
          type: sagaActions.UPDATE_DEFAULT_DOCK,
          payload: {
            CUID: cu_id,
              IDWarehouse: selectedWarehouse?.ID,
              DefaultIDDock: DefaultIDDock,
              CRUDTYPE: 'U'
          }
        })
        const newDockList = createDockList(whMetaDocksList)
        if (_.size(selectedDock)) {
        if (checkIfDockIsActive(whMetaDocksList, selectedDock[0])) {
            if (selectedDock[0].dockId !== "0000") {
              setSelectedDock(() => whMetaDocksList.filter((el) => el.dockId === selectedDock[0]?.dockId))
            }
            else {
              setSelectedDock(null)
            }
          }
        } else {
          if (_.size(newDockList) ) {
            const allDock = _.filter(newDockList, el => el.dockId === '0000')
            if (_.size(allDock)) {
              onDockSelected(allDock[0])
            }
          }
        }
    }
    }, [whMetaDocksList])
  
    useEffect(() => {
      if (defaultDockValue) {
       
        setDefaultDockValueState(defaultDockValue)
      } else {
        setDefaultDockValueState(null)
      }
    }, [defaultDockValue, dockList])
    
    useEffect(() => {
  
      if (defaultDockValueState) {
         if (defaultDockValue && _.size(dockList)) {
        if (defaultDockValue && _.isEmpty(selectedDock)) {
          if (_.size(dockList)) {
            const filterDock = _.filter(dockList, { dockId: defaultDockValue })
            if (filterDock) {
              onDockSelected(filterDock[0])
            }
          }
        }
        else if (!_.isEmpty(selectedDock) && selectedDock?.dockName !== 'ALL') {
          if (_.size(dockList)) {
            const filterDock = _.filter(dockList, { dockId: defaultDockValue })
            if (filterDock) {
              onDockSelected(filterDock[0])
            }
          }
        }
      }
      } 
  
     
    }, [defaultDockValueState, dockList])
  
    useEffect(() => {
      if (_.size(selectedDock)) {
        // if defaultDockValue and selectedDock idDock are equal then make Default Dock as checked
        if (defaultDockValue && defaultDockValue === selectedDock[0]?.ID) {
          setDefaultDockValueState(defaultDockValue)
        } else {
          setDefaultDockValueState(null)
        }
      }
    },[selectedDock])


    useEffect(() => {
      if (_.size(selectedDock) && selectedDock[0]) {
        const dockData = selectedDock[0];
        if (dockData.dockId === "0000") {
          setDockOperationalDays({
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true
          });
        } else {
          setDockOperationalDays({
            sunday: dockData.sunday === true,
            monday: dockData.monday === true,
            tuesday: dockData.tuesday === true,
            wednesday: dockData.wednesday === true,
            thursday: dockData.thursday === true,
            friday: dockData.friday === true,
            saturday: dockData.saturday === true
          });
        }
      } else {
        setDockOperationalDays({
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true
        });
      }
    }, [selectedDock])

    useEffect(()=>{
        if (appointmentList.length) {
          // let response=formatLeaveDataForScheduler([...wpLeaveData])
          //   setApptList([..._.orderBy(formatDataForScheduler(appointmentList),"end","asc"),...response])
          if (_.size(selectedDock) && selectedDock[0].dockId !== '0000') {
            let dockselectedlist = appointmentList.filter((el) => el.IDDock === selectedDock[0].dockId)
            let combinedList = [..._.orderBy(formatDataForScheduler(dockselectedlist),"start","asc")];
            if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
              const filteredStanding = standingAppointmentBlocksForScheduler.filter(appt => appt.IDDock === selectedDock[0].dockId && !hasConflictingAppointment(appt, dockselectedlist));
              combinedList = [...combinedList, ...filteredStanding];
            }
            setApptList(combinedList);
          } else {
            
            let combinedList = [..._.orderBy(formatDataForScheduler(appointmentList),"start","asc")];
            if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
              const filteredStanding = standingAppointmentBlocksForScheduler.filter(appt => !hasConflictingAppointment(appt, appointmentList));
              combinedList = [...combinedList, ...filteredStanding];
            }
            setApptList(combinedList);
          }
        } else if (!appointmentList.length && !shouldRender) {
          let combinedList = [];
          if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
            if (_.size(selectedDock) && selectedDock[0].dockId !== '0000') {
              combinedList = standingAppointmentBlocksForScheduler.filter(appt => appt.IDDock === selectedDock[0].dockId && !hasConflictingAppointment(appt, []));
            } else {
              combinedList = standingAppointmentBlocksForScheduler.filter(appt => !hasConflictingAppointment(appt, []));
            }
          }
          setApptList(combinedList);
        }
      
    }, [appointmentList, whMetaDocksList, standingAppointmentBlocksForScheduler, selectedDock])

  

  const onDockSelected = (data) => {
        if (data?.dockId && data?.dockId!=="0000") {
          setSelectedDock(() => whMetaDocksList.filter((el) => el.dockId === data.dockId))
          const filterData = whMetaDocksList.filter((el) => el.dockId === data.dockId)
          if(_.size(filterData)){
            
            setPlaceHolderDock(filterData[0].Name)
          }
        }
        else{
          setSelectedDock(null)
          setPlaceHolderDock("ALL")
        }
        let dockselectedlist=[]
        if (appointmentList && appointmentList.length) {
          if (data?.dockId==="0000") {
            dockselectedlist=[...appointmentList]
            setStartHour(data.dockStart)
            setEndHour(data.dockEnd)
            // setBreakList(whBreaks) // Removed, handled by useEffect
        //     if (wpLeaveData.length) {
        //     if (wpLeaveData.length) {
        // let response=formatLeaveDataForScheduler([...wpLeaveData],data.dockStart,data.dockEnd)
        //       setEventList([])
        //       setApptList([..._.orderBy(formatDataForScheduler(appointmentList),"end","asc"),...response])
              
        //     }
        //     else{
        //       setEventList([])
        //       setApptList([..._.orderBy(formatDataForScheduler(appointmentList),"end","asc")])
        //     }
            setEventList([])
            let combinedList = [..._.orderBy(formatDataForScheduler(appointmentList),"start","asc")];
            if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
              const filteredStanding = standingAppointmentBlocksForScheduler.filter(appt => !hasConflictingAppointment(appt, appointmentList));
              combinedList = [...combinedList, ...filteredStanding];
            }
            setApptList(combinedList);
          }
          else{
            setStartHour(data.dockStart)
            setEndHour(data.dockEnd)
            dockselectedlist=appointmentList.filter((el)=>el.IDDock===data.dockId)
            let dockselectedleavelist=[];
            let dockselectedbreakslist=[];
            dockselectedleavelist=whMetaLeavesList.filter((el)=>{
              if (el.IDDock===data.dockId && el.Status) {
                return el
              }
              })
              dockselectedbreakslist=dockBreaks.filter((el)=>{
                if (el.IDDock===data.dockId && el.Status) {
                  return el
                }
                })
              if (dockselectedbreakslist) {
                setBreakList(dockselectedbreakslist)
              }      
          // if (dockselectedlist.length || dockselectedleavelist.length) {  
             
          //   setEventList([])
          //   setApptList([..._.orderBy([...formatDataForScheduler(dockselectedlist),...formatLeaveDataForScheduler(dockselectedleavelist,data.dockStart,data.dockEnd)],"end","asc")])
          //   }
          // else{
          //   setEventList([])
          //     setApptList([])
          //   }
            if (dockselectedlist.length ) {  
             
              setEventList([])
              let combinedList = [..._.orderBy(formatDataForScheduler(dockselectedlist))];
              if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
                const filteredStanding = standingAppointmentBlocksForScheduler.filter(appt => appt.IDDock === data.dockId && !hasConflictingAppointment(appt, dockselectedlist));
                combinedList = [...combinedList, ...filteredStanding];
              }
              setApptList(combinedList);
              }
            else{
              setEventList([])
              let combinedList = [];
              if (standingAppointmentBlocksForScheduler && standingAppointmentBlocksForScheduler.length) {
                const filteredStanding = standingAppointmentBlocksForScheduler.filter(appt => appt.IDDock === data.dockId && !hasConflictingAppointment(appt, dockselectedlist));
                combinedList = [...combinedList, ...filteredStanding];
              }
              setApptList(combinedList);
              }
        }
      }

      }

    // export const isBetween=(data,start,end)=>{
    //     if (data>=start && data<=end) {
    //         return true
    //     }
    //     else{
    //     return false;
    // }
    // }

  //   const isOverlap=(data,list) => {

  //     const overlapedEvents=[]
  //     let newlist=list.filter((el)=>el.event_id!==data.event_id)
  //     if (newlist.length) {

  //     for (let index = 0; index < newlist.length; index++) {
  //         const element = newlist[index];
  //         let startTime=element.start.getTime()
  //         let endTime=element.end.getTime()
          
  //         let currentStart=data.start.getTime()
  //         let currentEnd=data.end.getTime()
  //         if (isBetween(currentStart,startTime,endTime) || isBetween(currentEnd,startTime,endTime)) {
  //             // if (currentStart>=startTime) {
  //             //     overlapedEvents.push(data)
  //             // }
  //             // else{
  //             overlapedEvents.push(element)
  //         }
  //     //    }
          
  //     }
              
  //   }
  //     return overlapedEvents
  // }


//   //const eventList=[]
//   const genrateEventList=(data) => {

//     let overlapFixedEvents=[]
//   if (data.length) {
//       for (let index = 0; index < data.length; index++) {
//           const element = data[index];
//           if (element) {
//           let overlap=[];
//           let isResolved=overlapFixedEvents.filter((el)=>el.event_id===element.event_id)
//           if (!isResolved.length) {
//           overlap= isOverlap(element,data)
//           if (overlap.length>0) {
//                 let newlist=eventList;
//               let res={...element};
//               res.show_more=false;
//               let moreEvents=[];
//             //   let neweve=[]
//               for(let i=0;i<overlap.length;i++){
//                  //neweve=event.filter((el)=>el.event_id!=overlap[i].event_id)
//                 overlapFixedEvents.push(overlap[i])
//                 if (element.PORelationID!==overlap[i].PORelationID) {
//                     res.show_more=true;
//                     moreEvents.push(overlap[i])
//                 }
//                   //setEvent(neweve)
//               }
//               res.more_event_list=[...moreEvents]
//               newlist.push(res)
              
//               setEventList([..._.uniqBy(newlist,'event_id')])
            
//           }
//           else{
//             let newlist=eventList;
//               let res={...element};
//               res.show_more=false;
//               res.more_event_list=[]
//               newlist.push(res)
//               setEventList([..._.uniqBy(newlist,"event_id")])
//           }
                
//         }
//     }
       
//       }
//   }
//   else{

//     setEventList([])
//   }

// }


// Function to check if two appointments overlap
function doAppointmentsOverlap(appointment1, appointment2) {
  return (
      appointment1.start < appointment2.end &&
      appointment2.start < appointment1.end
  );
}

// Function to find overlapping appointments for each appointment
function findOverlappingGroups(appointments) {
  const overlappingGroups = [];

  for (let i = 0; i < appointments.length; i++) {
      const currentAppointment = appointments[i];
      let foundGroup = false;

      for (let j = 0; j < overlappingGroups.length; j++) {
          const group = overlappingGroups[j];

          for (const appointment of group) {
              if (doAppointmentsOverlap(currentAppointment, appointment)) {
                  group.push(currentAppointment);
                  foundGroup = true;
                  break;
              }
          }

          if (foundGroup) {
              break;
          }
      }

      if (!foundGroup) {
          overlappingGroups.push([currentAppointment]);
      }
  }

  return overlappingGroups;
}

  useEffect(() => {
  let tout;
  const stopLoading=()=>{
   
  }
  if (apptList.length) {
    
    // genrateEventList([...apptList])
    //new 

// Find overlapping groups
let appointmentListArray=[..._.orderBy(apptList,"start","asc")]
const overlappingGroups = findOverlappingGroups(appointmentListArray);
    setEventList(overlappingGroups)
   stopLoading()
  }
  else{
    setEventList([])
    stopLoading()
  }

  return(()=>clearTimeout(tout))
},[apptList,startHour,endHour])


const getToggleSwitch = (value, index) => {
  return (
      <div className='d-flex justify-content-center align-items-center py-1'>
          <CommonToggleSwitch value={false}
        onChangeValue={(value) => {
          dispatch({
            type: sagaActions.UPDATE_DEFAULT_DOCK,
            payload: {
              CUID: cu_id,
                IDWarehouse: selectedWarehouse?.ID,
                DefaultIDDock: null,
                CRUDTYPE: 'U'
            }
          })
          setTimeout(() => {
            navigate('/schedulerweek')
          }, 0);
        }} 
              allowPermissionD={true}
              />
      </div>
  )
  }
  
   /** Function to update Default Dock */ 
  const onDefaultDockChange = (data, checked) => {
    if (_.size(selectedDock)) {
      dispatch({
        type: sagaActions.UPDATE_DEFAULT_DOCK,
        payload: {
          CUID: cu_id,
            IDWarehouse: selectedWarehouse?.ID,
            DefaultIDDock: selectedDock[0]?.ID,
            CRUDTYPE: 'I'
        }
      })
    }
  }

  const weekShiftHandler = (type) => {
    if (type === 'prev') {
      const newDate = addDaysToDate(selectedDate, -7)
      setSelectedDate(newDate)
    } else if (type === 'next') {
      const newDate = addDaysToDate(selectedDate, 7)
      setSelectedDate(newDate)
    }
  }

  return (
    <ScheduleProWrapper showAppointments={false} showNavBar={true}>
      <div className="my-scheduler-ss-wrapper p-3">
        <div className="rs__scheduler__wrapper">
          <div className="d-flex justify-content-between">
            <p className="f-16 fw-semibold ms-3"></p>

            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="pos-rel">
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    className="date-picker-btn h-100 ms-1"
                    onClick={() => setShowCalendar(!showCalendar)}
                  >
                    <span className="btn-title ">
                   
                      {selectedDate
                        ?`${format(new Date(selectedDate),"PPP")}`
                        : "Select Date"}
                    </span>
                    {showCalendar ? (
                      <span
                        className="font-default"
                        onClick={() => setShowCalendar(false)}
                      >
                        <i
                          className="fa-solid fa-xmark"
                          style={{ marginInline: "9px" }}
                        ></i>
                      </span>
                    ) : (
                      <span className="font-default">
                        <i
                          className="fas fa-calendar-week"
                          style={{ marginInline: "9px" }}
                        ></i>
                      </span>
                    )}
                  </button>
                  <div className='cursor-pointer ms-2' onClick={() => {weekShiftHandler('prev')}}>
                  <span title="Previous Week"> <i
                          className="fa-solid fa-angle-left fa-lg"
                          style={{ marginInline: "9px" }}
                        ></i></span>
                </div>
                  <div className='cursor-pointer' onClick={() => {weekShiftHandler('next')}}>
                  <span title="Next Week"> <i
                          className="fa-solid fa-angle-right fa-lg"
                          style={{ marginInline: "9px" }}
                        ></i></span>
                  </div>
                  <div className='cursor-pointer ms-2' onClick={() => {
                    setSelectedDate(new Date())
                  }}>
                    <span>Today</span>
                    <i
                          className="fas fa-calendar-day"
                          style={{ marginInline: "9px" }}
                        ></i>
                  </div>
              </div>
                  {showCalendar && (
                    <div
                      className="myappt-ss-datePicker"
                      style={{ zIndex: "999999999" }}
                    >
                      <DatePickerSS
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        setLoading={false}
                        closeCalendar={() => {
                          setShowCalendar(!showCalendar);
                        }}
                      />
                      
                    </div>
                  )}
              </div>
              <div className='d-flex justify-content-end gap-2'>
              <CustomButtonSS
                  disabled={false}
                  isLoading={false}
                  className={`carrier-po-btn-small`}
                  onClick={() => {navigate(0)}}
                  isIcon={true}
                  iconClass={"fa-solid fa-rotate-right"}
                />

                <CustomButtonSS
                  isLoading={false}
                  title={
                    AppConstant.smartScheduler.searchAppointments.newApptBtnText
                  }
                  className={"btn-highlighted f-12 me-3"}
                  onClick={() => {
                    setShowScheduleModal(true)
                  }}
                  isIcon={true}
                  iconClass={"fa-solid fa-plus fa-lg color-white"}
                />
              {/* Commented on 06 Feb 2026 asked by rajesh */}
              {/* <div className='d-flex align-items-center'>
              <p className="me-2 mb-1 fw-600 f-14">Weekly Calendar View</p>
                {getToggleSwitch()}
                </div> */}
              </div>
              </div>
          </div>
          <div className="table-ss p-3">
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-2">
              
                {shouldRender ? <div
                  className="d-flex flex-row fs-6 align-items-center ms-1"
                  style={{ zIndex: "998" }}
                >
                  <p className="f-12">Select a Dock &nbsp; </p>{" "}
                  <CustomDropDownSS
                    themeSelected={props.themeSelected}
                    data={dockList}
                    placeHolder={placeHolderDock || 'ALL'}
                    onSelect={onDockSelected}
                    keyStr={"dockName"}
                  />
                </div> :''}
                {dockList && selectedDock && _.size(dockList) && shouldRender && selectedDock?.dockName !== 'ALL' ? <div className='ms-2'>
          {
            <div className='mt-2'>
              <div className="default-dock f-12">
              <label htmlFor="defaultDock">
                <span className="btn_title">{AppConstant.commonStrings.defaultDock}</span>
                </label>{" "}
                <div className='ms-2'>
                <input
                    type='checkbox'
                    value={defaultDockValueState}
                    name='defaultDock'
                  className={'customTextInputError'}
                  checked={defaultDockValueState ? true : false }
                    // onBlur={(data) => props.handleErrors(data.target.name)}
                    onInput={(data) => onDefaultDockChange(data.target.value, data.target.checked)}
                    // disabled={disabled || ''}
                />
                  </div>
            </div>
            </div>
          }
        </div> : ''}
              </div>
              <div className="d-flex gap-1">
                <div className="d-flex gap-2 me-4">
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__schedule" />
                    Scheduled
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__reschedule" />
                    Rescheduled
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__inprogress" />
                    In Progress
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code_completed" />
                    Completed
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__Leaves" />
                    Holiday
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code_closed" />
                    Closed
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__break" />
                    Breaks
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code__standing-appointment" />
                    Standing Appts
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code_po_inbound" />
                    Inbound
                  </div>
                  <div className="f-12 fw-600 d-flex align-items-center gap-2">
                    <div className="code_po_outbound" />
                    Outbound
                  </div>
                </div>
              </div>
            </div>
            {shouldRender ? (
              <Week
                dateSelected={selectedDate}
                events={readyWeekData.events}
                startHour={0}
                endHour={24}
                selectedDock={selectedDock}
                breakList={readyWeekData.breaks}
                showScheduleModal={showScheduleModal}
                setShowScheduleModal={setShowScheduleModal}
                leaveList={readyWeekData.leaves}
                dockList={dockList}
                dockOperationalDays={dockOperationalDays}
                whMetaDocksList={whMetaDocksList}
              />
            ) : (
              isInitialized ? (
                <div className="w-100 p-3">{showLoaderScheduler("")}</div>
              ) : null
            )
            }
            {/* <div className="d-flex gap-3 mx-3">
              <div className="f-12 fw-600 d-flex align-items-center gap-2">
                <div className="code__schedule" />
                Scheduled
              </div>
              <div className="f-12 fw-600 d-flex align-items-center gap-2">
                <div className="code__reschedule" />
                Rescheduled
              </div>
              <div className="f-12 fw-600 d-flex align-items-center gap-2">
                <div className="code_closed" />
                Closed
              </div>
              <div className="f-12 fw-600 d-flex align-items-center gap-2">
                <div className="code__break" />
                Breaks
              </div>
            </div> */}
          </div>
        </div>
        {showScheduleModal && searchedPOData.length===0 &&
       <ModalSS toggleModal={()=>{
        setShowScheduleModal(!showScheduleModal);
        setPo_number("")
        }}>
          <div className='p-2' style={{width:"400px",height:"auto"}}>
                                    <SSAppointmentSearch toggleIsSearched={toggleIsSearched}
                                        {...props} searchAppointment={() => displayAppointmentsList()}
                                        onEmailChange={(e, type) => onEmailChange(e, type)} initateLoading={initateLoading}
                                        scheduleScreenType={scheduleScreenType} setScheduleScreenType={setScheduleScreenType}
                                        showPdfHelperPopup={() => setShowHelpModal(true)}
                                        userType={userType} po_number={po_number} receivingZipcode={receivingZipcode} searchedPOErrorData={searchedPOErrorData}
                                        showHighLight={false}
                                    />
                                </div>
      </ModalSS>
      }
      </div>
    </ScheduleProWrapper>
  );
}

export default SchedulerNewSS